import { Injectable } from '@angular/core';

@Injectable()
export class UrlSignature {
  applicationName = '/techbridge';
  environment = '-dev';
  acdtUrl = 'https://techbridge.edu.gh';
  aucdtUrl = 'https://api.techbridge.edu.gh';
  baseUrl = this.aucdtUrl + this.applicationName + this.environment;
  //baseUrl = 'http://localhost:8181';
  academicYeartUrl = this.baseUrl + '/academicYears';
  acceptedApplicantsExcelUrl = this.baseUrl + '/acceptedApplicantsExcel/';
  addressUrl = this.baseUrl + '/address/';
  allCommentsExcel = this.baseUrl + '/allcomments';
  applicantCommentsExcel = this.baseUrl + '/commentsForApplicantId/';
  applicantCountUrl = this.baseUrl + '/totalApplicantsForProgrammeId/';
  applicantListUrl = this.baseUrl + '/applicants/';
  applicantStatusWithGenderApplicantsExcelUrl =
    this.baseUrl + '/applicantStatusWithGenderApplicantsExcel/';
  applicantStatusWithResidenceApplicantsExcelUrl =
    this.baseUrl + '/applicantStatusWithResidenceApplicantsExcel/';
  applicantTypeListUrl = this.baseUrl + '/acceptedApplicantsList/';
  applicantTypeListregUrl = this.baseUrl + '/registeredApplicantsList/';
  applicantTypeWithGenderApplicantsExcelUrl =
    this.baseUrl + '/applicantTypeWithGenderApplicantsExcel/';
  applicantTypeWithResidenceApplicantsExcelUrl =
    this.baseUrl + '/applicantTypeWithResidenceApplicantsExcel/';
  applicantUrl = this.baseUrl + '/applicant/';
  certificateApplicantsExcelUrl = this.baseUrl + '/certificateApplicantsExcel/';
  certificateLinkUrl =
    this.acdtUrl + '/attachments' + this.environment + '/results/';
  certificateProgrammeListUrl = this.baseUrl + '/certificateProgrammeList';
  certificatesUrl = this.baseUrl + '/certificates';
  certificationUrl = this.baseUrl + '/certification';
  cityByIdUrl = this.baseUrl + '/city/';
  commentUrl = this.baseUrl + '/comment';
  contactByIdUrl = this.baseUrl + '/contact/';
  contactUrl = this.baseUrl + '/person/contact/';
  countryListUrl = this.baseUrl + '/countryCodes';
  countryUrl = this.baseUrl + '/country/';
  currentYearUrl = this.baseUrl + '/currentYear';
  degreeApplicantsExcelUrl = this.baseUrl + '/degreeApplicantsExcel/';
  diplomaApplicantsExcelUrl = this.baseUrl + '/diplomaApplicantsExcel/';
  excelUrl = this.baseUrl + '/excel/';
  excelAcceptedUrl = this.baseUrl + '/acceptedApplicantsExcel/';
  excelRegisteredUrl = this.baseUrl + '/registeredApplicantsExcel/';
  financingDetailsUrl = this.baseUrl + '/financing';
  genderListUrl = this.baseUrl + '/genderList';
  getSignUpUrl = this.baseUrl + '/signUp/';
  institutionUrl = this.baseUrl + '/institutions/';
  // loginUrl = this.baseUrl + '/administrator/userName/';
  loginAuthUrl = this.baseUrl + '/admin/auth';
  pdfUrl = this.baseUrl + '/pdf/';
  personByIdUrl = this.baseUrl + '/personId/';
  personDetailsUrl = this.baseUrl + '/personId/';
  photoLinkUrl = this.acdtUrl + '/attachments' + this.environment + '/passports/';
  portfolioListUrl = this.baseUrl + '/portfolio';
  previousEnrollmentByIdUrl = this.baseUrl + '/previousEnrollment/';
  programmeListUrl = this.baseUrl + '/programme';
  programmeTypesUrl = this.baseUrl + '/programmeTypes';
  regionListUrl = this.baseUrl + '/regionList';
  rejectedApplicantsExcelUrl = this.baseUrl + '/rejectedApplicantsExcel/';
  religionListUrl = this.baseUrl + '/religion';
  residentBasedApplicantsExcelUrl = this.baseUrl + '/residenceApplicantsExcel/';
  signUpApplicantsExcelDownloadUrl = this.baseUrl + '/signUpApplicantsExcel';
  signUpApplicantsUrl = this.baseUrl + '/signUpApplicants/';
  signUpApplicantUrl = this.baseUrl + '/signUp/';
  sponsorDetailsUrl = this.baseUrl + '/sponsor';
  subjectsUrl = this.baseUrl + '/subjects/';
  titleListUrl = this.baseUrl + '/titleList';
  totalApplicantCountUrl = this.baseUrl + '/totalApplicants';
  waitlistedApplicantsExcelUrl = this.baseUrl + '/waitlistedApplicantsExcel/';

  // CTVET endpoints
  ctvetStudentRegister = this.baseUrl + '/api/ctvet/savestudentinfo';
  ctvetAllStudents = this.baseUrl+ '/api/ctvet/ctvetstudents';
  ctvetStudentSaveAttendance = this.baseUrl + '/api/ctvet/saveattendance';
  ctvetallStudentAttendance = this.baseUrl+ '/api/ctvet/ctvetallattendance';


  //New! Sys admin endpoints
  sysaccountcreationurl = this.baseUrl + '/api/admin-users';
  sysadminloginurl = this.baseUrl + '/api/auth/sysadminlogin';
  sysusersbyroleurl = this.baseUrl + '/api/admin-users/by-admin-type/';


  // Endpoints for Registration, Admin, Super Admin, and Applicant users
  ShowallNewSignups = this.baseUrl + '/api/admin/signups/all'
  NoofNewApplicantsinthecurrentmonth = this.baseUrl + '/api/admin/signups/stats/pending/month';
  NoofNewApplicantsinthecurrentyear = this.baseUrl + '/api/admin/signups/stats/pending/year';
  CurrentMonthApplicantUrl = this.baseUrl + '/api/admin/signups/current-month';
  monthlySignupStatsUrl = this.baseUrl + '/api/admin/signups/stats/monthly';

//   application review
applicantRegistryAllUrl  = this.baseUrl + '/api/admin/applicants/all';
applicantRegistryStatusUpdateUrl = this.baseUrl + '/api/admin/applicants/status/update';


//    finance
summaryUrl               = this.baseUrl + '/api/admin/application-fees/summary';
getalltransacionsurl     = this.baseUrl + '/api/admin/application-fees';
transactionDetailUrl     = this.baseUrl + '/api/admin/application-fees/detail/';
successapplicationpaymenturl = this.baseUrl + '/api/admin/application-fees/successful';
pendingapplicationpaymenturl = this.baseUrl + '/api/admin/application-fees/pending';
failedapplicationpaymenturl  = this.baseUrl + '/api/admin/application-fees/failed';


//  school fees urls
AddfeeItemsUrl = this.baseUrl + '/api/admin/fee-items';
retrievefeesitemsurl = this.baseUrl + '/api/admin/fee-items';


// Old data from old asanska DB

retrievealloldapplicanturl = this.baseUrl + '/applicants/';
oldApplicantRegistryStatusUpdateUrl = this.baseUrl + '/applicants/status';



}
